import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Headphones } from "lucide-react";

import Layout from "../../layout/Layout";
import Header from "../../layout/Header";
import CGMStatusCard from "src/components/app/cgm/steps/CGMStatusCard";
import CGMConnectionGuide from "../connection/CGMConnectionGuide";
import CGMConnectVideoTutorials from "../connection/CGMConnectVideoTutorials";

const ConnectedStep: React.FC = () => {
  const params = useParams();
  const supportProgramKey = params["support-program-key"] ?? "";
  const navigate = useNavigate();
  return (
    <Layout
      supportProgramKey={supportProgramKey}
      className="bg-white"
      containerClassName="bg-white"
      header={
        <Header
          title="Back"
          onBackClick={() => navigate(-1)}
          rightComponent={
            <button
              className="mr-16 flex items-center gap-2 whitespace-nowrap font-semibold text-[var(--app-primary)]"
              onClick={() =>
                navigate(`/app/${supportProgramKey}/cgm-need-help`)
              }
            >
              <Headphones />
              Need Help?
            </button>
          }
        />
      }
    >
      <CGMStatusCard />
      <CGMConnectionGuide />
      <CGMConnectVideoTutorials className="px-4" />
    </Layout>
  );
};

export default ConnectedStep;
